import React from 'react';
import PropTypes from 'prop-types';
import './SurveysTable.css';
import SimpleTable from 'components/shared/table/SimpleTable';
import SimpleText from 'components/shared/text/SimpleText';
import Date from 'components/shared/text/Date';
import Number from 'components/shared/text/Number';
import SurveyRating from 'components/admin/surveys/SurveyRating';

function mapSurveys(surveys, showClient) {
  return surveys.map((survey) => {
    return [
      survey.work_order.number,
      showClient ? (
        <div className="client-name">
          {survey.work_order.client.company_name}
        </div>
      ) : undefined,
      <SimpleText
        lines={[
          survey.work_order.building.location.street_address_1,
          survey.work_order.building.location.city,
        ]}
      />,
      <SurveyRating rating={survey.rating} />,
      <Date value={survey.work_order.started_at} format="ll" />,
      <Date value={survey.work_order.completed_at} format="ll" />,
      <Number value={survey.work_order.approved_proposal.cost} format="$0,0" />,
      survey.work_order.approved_proposal.variance !== null
        ? `${survey.work_order.approved_proposal.variance}%`
        : 'N/A',
    ].filter((notNull) => notNull);
  });
}

export default function SurveysTable(props) {
  const classNames = ['surveys-table'];
  let headers = ['WO #'];
  if (props.showClient) {
    classNames.push('with-client');
    headers.push('CLIENT NAME');
  }
  headers = headers.concat([
    'LOCATION',
    'STATUS',
    'START DATE',
    'END DATE',
    'WO AMOUNT',
    'VARIANCE',
  ]);
  return (
    <SimpleTable
      className={classNames.join(' ')}
      headers={headers}
      emptyMessage="No Surveys yet!"
      rows={mapSurveys(props.surveys, props.showClient)}
      onRowSelected={props.onRowSelected}
      onGenerateLink={props.onGenerateLink}
    />
  );
}

SurveysTable.propTypes = {
  showClient: PropTypes.bool.isRequired,
  surveys: PropTypes.arrayOf(PropTypes.shape({})),
  onRowSelected: PropTypes.func,
  onGenerateLink: PropTypes.func,
};

SurveysTable.defaultProps = {
  surveys: [],
};



// WEBPACK FOOTER //
// ./src/components/admin/surveys/SurveysTable.js